import { createApiConstants } from '@saucelabs/sl-util-redux';


export const NAMESPACE = 'jobs-users';
const createApiNamespacedConstants = createApiConstants.bind(null, NAMESPACE);

export const USER_GET = createApiNamespacedConstants('USER_GET');
export const USER_GET_RESTO = createApiNamespacedConstants('USER_GET_RESTO');
export const INITIALIZE = `${NAMESPACE}/INITIALIZE`;
export const CLEANUP = `${NAMESPACE}/CLEANUP`;
